import * as googleApi from '@googlemaps/js-api-loader'
import * as Sentry from '@sentry/vue'

// @ts-expect-error Say thanks Google Inc for such a beautiful code
import GeocodingLibrary = google.maps.GeocodingLibrary

// @ts-expect-error Say thanks Google Inc for such a beautiful code
import PlacesLibrary = google.maps.PlacesLibrary

const { Loader } = googleApi

const geoCoderService = ref<google.maps.Geocoder | undefined>()
const geoCoderServiceLoading = ref(false)

const autoCompleteService = ref<google.maps.places.AutocompleteService | undefined>()
const autoCompleteServiceLoading = ref(false)

export function useGoogleAPI() {
  const loader = new Loader({
    apiKey: useRuntimeConfig().public.google.apiKey,
  })

  if (!geoCoderService.value && !geoCoderServiceLoading.value) {
    geoCoderServiceLoading.value = true
    loader.importLibrary('geocoding')
      .then((geocodingLibrary: GeocodingLibrary) => {
        geoCoderService.value = new geocodingLibrary.Geocoder()
      })
      .catch((e: Error) => {
        Sentry.captureException(e)
        console.error('Error while loading the geocoder', e)
      })
      .finally(() => {
        geoCoderServiceLoading.value = false
      })
  }

  if (!autoCompleteService.value && !autoCompleteServiceLoading.value) {
    autoCompleteServiceLoading.value = true
    loader.importLibrary('places')
      .then((placesLibrary: PlacesLibrary) => {
        autoCompleteService.value = new placesLibrary.AutocompleteService()
      })
      .catch((e: Error) => {
        Sentry.captureException(e)
        console.error('Error while loading the geocoder', e)
      })
      .finally(() => {
        autoCompleteServiceLoading.value = false
      })
  }

  return {
    geoCoderService: readonly(geoCoderService),
    autoCompleteService, // cannot be readonly as seems that the API call modify it
  }
}
